/**
 * Overwrite request success to refresh all widget without current Widget_Form if allow_reload
 *
 * @param  {object} widget  - The widget to search on.
 * @return this
 */
Charcoal.Admin.Widget_Form.prototype.request_success = function ($form, $trigger, response/* textStatus, jqXHR */) {
    this.confirmed = false;

    if (response.feedbacks) {
        Charcoal.Admin.feedback(response.feedbacks);
    }

    if (response.need_confirmation) {
        Charcoal.Admin.feedback()
            .add_action({
                label:    commonL10n.cancel,
                cssClass: 'btn-danger',
                callback: function () {
                    BootstrapDialog.closeAll();
                }
            })
            .add_action({
                label:    commonL10n.continue,
                callback: function () {
                    //TODO THIS IS NOT IDEAL ... In the future,
                    // receiving an instance of BootstrapDialog would be better,
                    // unfortunately, this is not the case. Good day sir.
                    BootstrapDialog.closeAll();

                    this.confirmed = true;
                    this.submit_form($form[0]);
                }.bind(this)
            });
    }

    if (response.next_url) {
        // @todo "dynamise" the label
        Charcoal.Admin.feedback().add_action({
            label:    commonL10n.continue,
            callback: function () {
                window.location.href = Charcoal.Admin.admin_url() + response.next_url;
            }
        });
    }

    if (!this.useDefaultAction && this.is_new_object) {
        this.suppress_feedback = true;

        if (response.next_url) {
            window.location.href = Charcoal.Admin.admin_url() + response.next_url;
        } else {
            var params = new URLSearchParams(window.location.search);

            window.location.href =
                Charcoal.Admin.admin_url() +
                'object/edit?' +
                (params.has('main_menu') ? 'main_menu=' + params.get('main_menu') + '&' : '') +
                (params.has('secondary_menu') ? 'secondary_menu=' + params.get('secondary_menu') + '&' : '') +
                'obj_type=' + this.obj_type +
                '&obj_id=' + response.obj_id;
        }
    }
    else {
        if (this.allow_reload) {
            var manager = Charcoal.Admin.manager();
            var widgets = manager.components.widgets;

            $.each(widgets, function (i, widget) {
                if (widget instanceof Charcoal.Admin.Widget_Form) {
                    return true;
                }
                try {
                    widget.reload();
                } catch (error) {
                    console.log(error, widget);
                }
            }.bind(this));
        }
    }
};

/**
 * Overwrite Object Revisions constructor to remove call to Charcoal.Admin.parseNumber for obj_id.
 * This is because the obj_id is not always a number but may contain only numbers (ex.: MRC 010)
 *
 * @param  {object} widget  - The widget to search on.
 * @return this
 */
Charcoal.Admin.Widget_Object_Revisions.prototype.constructor = function (opts) {
    Charcoal.Admin.Widget.call(this, opts);

    this.extra_form_data = opts.extra_form_data || {};

    this.xhr = null;
    this.obj_id = opts.obj_id;
    this.obj_type = opts.obj_type;

    return this;
};
